export const PAGE_SIZE = 12;
export const PAGE_SIZE_OPTIONS = [12, 24, 50];
